import { render, staticRenderFns } from "./DynamicMenuTree.vue?vue&type=template&id=e80fd4f2&scoped=true&"
import script from "./DynamicMenuTree.vue?vue&type=script&lang=js&"
export * from "./DynamicMenuTree.vue?vue&type=script&lang=js&"
import style0 from "./DynamicMenuTree.vue?vue&type=style&index=0&id=e80fd4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80fd4f2",
  null
  
)

export default component.exports